import { TFunction } from 'i18next';
import z from 'zod';
import { NumberTypeEnum } from '../../../../../../types/generated/graphql';

export const claimNumbersSchema = (
  maxCount: number,
  getIsoCountryForNumber: (phoneNumber: string) => string | undefined,
  t: TFunction
) =>
  z
    .object({
      isoCountry: z
        .string({ required_error: t('required') })
        .trim()
        .min(1, { message: t('required') }),
      numberType: z.nativeEnum(NumberTypeEnum).optional(),
      capabilities: z.any(),
      matchTo: z.any(),
      numbers: z
        .array(
          z.object({
            phoneNumber: z
              .string()
              .trim()
              .min(1, { message: t('choose_a_number_to_claim') }),
            friendlyName: z
              .string()
              .trim()
              .min(1, { message: t('enter_a_friendly_name') }),
          })
        )
        .min(1, { message: t('choose_at_least_one_number_to_claim') })
        .max(maxCount, {
          message: `You can claim at most ${maxCount} number${maxCount === 1 ? '' : 's'}`,
        }),
    })
    .superRefine((data, ctx) => {
      data.numbers.forEach((entry, index) => {
        const rowCountry = getIsoCountryForNumber(entry.phoneNumber);
        if (rowCountry && rowCountry !== data.isoCountry) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['numbers', index, 'phoneNumber'],
            message: t('this_number_belongs_to_a_different_country_than_the_selected_country'),
          });
        }
      });
    });

export type ClaimNumbersSchema = z.infer<ReturnType<typeof claimNumbersSchema>>;
